exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-tooltip__popper {\r\n  max-width: 300px;\r\n  border: none !important;\r\n  font-size: 13px !important;\r\n  line-height: 22px;\r\n  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;\r\n  -webkit-box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.1) !important;\r\n          box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.1) !important;\n}\r\n", ""]);

// exports
